// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CustomTag_wrapper__4IE29","text":"CustomTag_text__DqYL6"};